// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2b9US","sendOtp":"AuthorizeToLogin_sendOtp__f09-p"};